import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { HomePage } from './pages/HomePage';
import { CollectionsPage } from './pages/CollectionsPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<HomePage data-id="element-4" />} data-id="element-3" />
          <Route path="/collections" element={<CollectionsPage data-id="element-6" />} data-id="element-5" />
          <Route path="/about" element={<AboutPage data-id="element-8" />} data-id="element-7" />
          <Route path="/contact" element={<ContactPage data-id="element-10" />} data-id="element-9" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}